import { Save } from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { textFieldProps } from "../shared/constants";
import FileUploader from "../shared/FileUploader";
import { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDb } from "../../contexts/DatabaseContext";

export default function AddEditPopup({ open, close, popupId, popupData }) {
  const { addStandardDoc, updateDocument } = useDb();
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckbox = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.checked,
    });
  };

  const handleFileUploadUrl = (url) => {
    setFormState({
      ...formState,
      image: url,
    });
  };
  const handleClose = () => {
    setFormState({});
    close();
  };

  const handleExpiryDatePick = (d) => {
    setFormState({
      ...formState,
      expiry_date: d.toDate(),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // @ts-ignore
    setError(null);
    setLoading(true);
    try {
      if (popupId) {
        await updateDocument("popups", popupId, formState);
      } else {
        await addStandardDoc("popups", formState);
      }
      handleClose();
    } catch (err) {
      window.alert(err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (popupData) {
      setFormState(popupData);
    } else {
      setFormState({ active: true });
    }
  }, [open]);

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <DialogTitle>Add Popup</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item={8}>
              <TextField
                {...textFieldProps}
                label="Popup Title"
                name="title"
                onChange={handleChange}
                required
                value={formState.title}
              />
              <FileUploader getUrl={handleFileUploadUrl} />
              <TextField
                {...textFieldProps}
                multiline={true}
                rows={4}
                label="Body Text"
                onChange={handleChange}
                name="body"
                required
                value={formState.body}
              />
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={formState.active} />}
                  label="Active (Go live now)"
                  name="active"
                  onChange={handleCheckbox}
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={formState.expire} />}
                  label="Remove at future date"
                  name="expire"
                  onChange={handleCheckbox}
                />
              </FormGroup>
              {formState.expire && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleExpiryDatePick} />
                </LocalizationProvider>
              )}
            </Grid>
            <Grid item={4}>
              <Typography>Preview:</Typography>
              <div style={{ width: "400px" }}>
                <Card>
                  <CardHeader title={formState.title} />
                  <CardContent>
                    <img
                      src={formState.image}
                      style={{ width: "100%" }}
                      alt="UploadImage"
                    />
                    <Typography style={{ wordWrap: "break-word" }}>
                      {formState.body}
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button startIcon={<Save />} type="submit" disabled={loading}>
            Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
